var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('InputGroup',{ref:"editor",attrs:{"options":_vm.options,"value":_vm.value},on:{"change":_vm.changeHandle}})}
var staticRenderFns = []

export { render, staticRenderFns }